import "./EditStepModal.css";

import { useContext } from "react";

import { TemplateStepConstants } from "../../../../../../../../../../../constants";
import { WorkflowStepModel } from "../../../../../../../../../../../models";
import { ServiceError } from "../../../../../../../../../../../service/Shared";
import {
  ActionButtons,
  Column,
  ErrorBox,
  KanaTooltip,
  Modal,
  RadioButtonGroup,
  Row,
  Select,
  TextInput,
} from "../../../../../../../../../../../widget";
import { TasksBoardContext } from "../../../../../../TasksBoardContext";
import { useEditStepModal } from "./useEditStepModal";

interface EditStepModalProps {
  show: boolean;
  closeModal: () => void;
  workflowStep: WorkflowStepModel;
}

export const EditStepModal = ({ show, closeModal, workflowStep }: EditStepModalProps): JSX.Element => {
  const { workflowStageOptions, workflowStageLabel, isRepeatableWorkflowStage } = useContext(TasksBoardContext);
  const { step, setStep, handleEditStep, isHandleEditStepLoading, onCancel, errors } = useEditStepModal({
    closeModal,
    workflowStep,
  });

  return (
    <Modal show={show} title="Edit step" onClose={onCancel}>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleEditStep(e)}>
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <TextInput
              name="Step name"
              label="Step name*"
              placeholder="Add step name"
              value={step.stepName}
              maxLength={100}
              onChange={(value) => setStep({ ...step, stepName: value })}
            />
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <div className="EditStepModalPhaseSelectorWrapper">
              <Select
                label={`${workflowStageLabel}*`}
                placeholder={`Select ${workflowStageLabel.toLowerCase()}`}
                data={workflowStageOptions}
                value={step.phase}
                onChange={(value) => setStep({ ...step, phase: value })}
              />
            </div>
          </Column>
        </Row>
        {isRepeatableWorkflowStage(step.phase) && (
          <Row spacingV="ll">
            <Column offset={3} span={6}>
              <RadioButtonGroup
                label="Is this step repeatable for future cycle of monitoring?"
                tooltip={
                  <KanaTooltip
                    tooltipHeader=""
                    tooltipText="Select this option to repeat this step and tasks in the next cycle of monitoring"
                  />
                }
                data={TemplateStepConstants.REPEATABLE_RADIO_BUTTON_DATA}
                value={step.isRepeatable}
                onChange={(value) => setStep({ ...step, isRepeatable: value.target.value })}
              />
            </Column>
          </Row>
        )}
        <Row justify="center">
          <ActionButtons onCancel={onCancel} submitButtonLabel="Save" isLoading={isHandleEditStepLoading} />
        </Row>
      </form>
    </Modal>
  );
};
